<template>
  <div class="">
    <v-card class="blueCard" flat>
      <v-card-title
        >Uveitis, Vitritis, Vasulitis, &amp; Scleritis Utility</v-card-title
      >
    </v-card>

    <div v-if="showAll && uData">
      <UveitisHome :uData="uData"></UveitisHome>
    </div>
    {{ uData }}
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import UveitisHome from "@/components/conditionsStuff/UveitisHome";
// import GetJsonMixin from "@/assets/js/GetJsonMixin";

export default {
  name: "Uveitis",
  //   mixins: [GetJsonMixin],
  components: { UveitisHome },
  data: () => ({ uData: null, error: null, showAll: true }),
  methods: {
    getData() {
      ApiServices.genericApiCall("uveitis")
        .then((response) => {
          this.uData = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = "An API error occurred";
        });
    },
  },
  computed: {},

  mounted() {
    this.getData();
    // let params = this.$route.params;
    // this.name = params?.name ? params.name : null;
    // this.category = params?.category ? params.category : null;
    // this.search = params?.search ? params.search : null;
    // if (!this.name && !this.category && !this.search)
    //   this.category = "eyelid-eyelashes";
    // this.getJSON("dzCategories", "catJson"); // in the mixin
  },
  created() {},
};
</script>

<style scoped>
.titlebar {
  border: 1px solid #bfd5e5 !important;
}
</style>
